export default __webpack_public_path__ + "static/media/36I-102630_-15543_0.0659cfc2.jpg";